// update state
const setActionisrootSelected = (payload) => {
    return {
        type: "ISROOTESELECTED",
        payload
    }

}

export default setActionisrootSelected;



// WEBPACK FOOTER //
// ./src/actions/setActionisrootSelected.js